var _ellipse, _path, _circle, _circle2, _path2, _path3, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 26,
    rx: 17,
    ry: 19,
    stroke: "#38bdf8",
    strokeOpacity: 0.22,
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 32 Q18 14 24 12 Q30 14 30 32 Q24 36 18 32 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    r: 1.5,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 22,
    r: 1.5,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12 L24 8 M19 10 L24 8 L29 10",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16 L16 12 M34 16 L32 12",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 34,
    r: 1,
    fill: "#fbbf24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStress);
export default __webpack_public_path__ + "static/media/stress.509d4d8446af3113f876530156113849.svg";
export { ForwardRef as ReactComponent };